import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-27811390"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "wp-block-title"
};
const _hoisted_2 = { key: 2 };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "wp-modal-selected-label" }, "Website selected", -1));
const _hoisted_4 = { class: "wp-modal-selected-url" };
const _hoisted_5 = {
    key: 4,
    class: "more-options-block"
};
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "RPS (Request per second)", -1));
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Sitemap", -1));
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Path", -1));
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Server location to launch test", -1));
const _hoisted_10 = {
    key: 5,
    class: "wp-warning"
};
const _hoisted_11 = { class: "wp-request-access-text" };
const _hoisted_12 = { class: "wp-block-button-row" };
import { computed, inject, onBeforeMount, ref, watch, } from "vue";
import WebsiteSelector from "@/components/molecules/WebsiteSelector.vue";
import OneDeskButton from "@/components/atoms/OneDeskButton.vue";
import OneDeskInput from "@/components/atoms/OneDeskInput.vue";
import OneDeskDropdown from "@/components/atoms/OneDeskDropdown.vue";
import { useStore } from "@/shared/composables/useStore";
import WPLabels from "@/shared/json/wpLabels.json";
import { isKeyof } from "@/shared/utils/utils";
import RequestAccessModal from "@/views/WebPageTests/RequestAccessModal.vue";
import { getUserClaims, userCanPerformTestsOnWebsite } from "@/repositories/claims.repository";
import { launchWebPageTest, checkWebPageTestStatus } from "@/repositories/wp.repository";
import wpDurationTime from "@/shared/json/wpDurationTime.json";
import { AllActionTypes } from "@/store/action-types";
import { ReferenceValuesTypes } from "@/store/modules/reference-values/types";
import { getWebsiteDetails } from "@/repositories/inventory.repository";
import useToastNotify from "@/shared/composables/toastNotifyHelper";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WpBlock',
    props: {
        title: {},
        slug: { default: "" },
        siteName: { default: "" },
        fullUrl: { default: "" },
        urlId: { default: "" },
        isModal: { type: Boolean, default: false },
        closeModal: {},
        requestView: { type: Boolean },
        brand: { default: "" },
        market: { default: "" },
        wpType: { default: "" }
    },
    emits: ["showRequestView"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const eventBus = inject("eventBus");
        const notify = useToastNotify();
        const emit = __emit;
        const launchedTaskArray = ref([]);
        const store = useStore();
        const selectedUrl = ref();
        const selectedSite = ref(null);
        const moreOptions = ref(false);
        const isLoading = ref(false);
        const isModalOpen = ref(false);
        // load-testing options
        const rps = ref(30);
        const sitemap = ref(props.isModal
            ? props.fullUrl
                ? props.fullUrl + "/sitemap.xml"
                : ""
            : selectedUrl.value
                ? selectedUrl.value + "/sitemap.xml"
                : "");
        const serverLocationOptions = [
            { label: "South East Asia", value: "AP" },
            { label: "West Europe", value: "EU" },
            { label: "East US", value: "US" },
        ];
        // page-performance / accessibility options
        const path = ref("");
        const serverLocation = ref("");
        const userId = ref(store.getters.getAccount.id);
        const hasAccess = ref(false);
        const showMoreOptions = () => {
            moreOptions.value = !moreOptions.value;
        };
        const userClaims = ref([]);
        const retrieveUserClaims = async () => {
            userClaims.value = await getUserClaims(userId.value);
        };
        onBeforeMount(async () => {
            await store.dispatch(AllActionTypes.GET_REFERENCE_VALUES, ReferenceValuesTypes.WEBSITE);
            await retrieveUserClaims();
        });
        const canUserAccessSiteName = async (userId, siteName) => {
            userCanPerformTestsOnWebsite(userId, siteName).then((value) => {
                hasAccess.value = value;
            });
        };
        watch(selectedUrl, async () => {
            if (selectedUrl?.value?.id != null)
                selectedSite.value = await getWebsiteDetails(selectedUrl.value.id);
            if (selectedSite.value && selectedSite.value.fullSiteName && !props.isModal) {
                sitemap.value = selectedSite.value.fullSiteName + "/sitemap.xml";
                if (props.slug == "load-testing" || props.slug == "seo") {
                    const siteName = selectedSite.value.siteName;
                    await canUserAccessSiteName(userId.value, siteName);
                }
                else {
                    hasAccess.value = true;
                }
            }
            else {
                sitemap.value = "";
                hasAccess.value = false;
            }
        });
        watch(() => props.slug, () => {
            moreOptions.value = false;
            rps.value = 30;
            sitemap.value = "";
            path.value = "";
            serverLocation.value = "";
            selectedUrl.value = "";
        });
        const showCancelButton = computed(() => props.isModal);
        const showAccessBlock = computed(() => {
            if (props.isModal)
                return !hasAccess.value;
            else {
                if (selectedUrl.value &&
                    selectedUrl.value != null &&
                    selectedUrl.value.id != null)
                    return !hasAccess.value;
                else
                    return false;
            }
        });
        const computedSelected = computed(() => {
            let selected;
            if (!props.isModal) {
                selected = {
                    fullSiteName: selectedSite.value?.fullSiteName,
                    siteName: selectedSite.value?.siteName,
                    id: selectedSite.value?.id,
                    brand: selectedSite.value?.brand,
                    market: selectedSite.value?.market,
                };
            }
            else {
                selected = {
                    fullSiteName: props.fullUrl,
                    siteName: props.siteName,
                    id: props.urlId,
                    brand: props.brand,
                    market: props.market,
                };
            }
            return selected;
        });
        const testTypeLabel = computed(() => {
            const type = props.wpType.toUpperCase();
            let label = isKeyof(WPLabels, type) ? WPLabels[type] : "";
            if (props.slug == "load-testing")
                label = "a " + label;
            else {
                label = "an " + label + " test";
            }
            return label;
        });
        const disabled = computed(() => {
            return (!hasAccess.value ||
                !(selectedUrl.value && selectedUrl.value != null && !props.isModal) &&
                    !(props.siteName && props.siteName != null && props.isModal));
        });
        const launch = async () => {
            try {
                isLoading.value = true;
                const wpData = buildWpData();
                const result = await launchWebPageTest(wpData, props.wpType.toUpperCase());
                if (result) {
                    isLoading.value = false;
                    eventBus.emit("refresh", "refresh-tasks");
                    addTaskToArray(result);
                    notify("", "Test has been launched", "info");
                }
                if (props.isModal && props.closeModal)
                    props.closeModal();
                else {
                    selectedUrl.value = "";
                }
            }
            catch (error) {
                console.log(error);
            }
        };
        const addTaskToArray = (result) => {
            launchedTaskArray.value.push({
                id: result.id,
                wpType: props.wpType,
                durationTime: isKeyof(wpDurationTime, props.wpType) ? wpDurationTime[props.wpType] : 10000,
            });
        };
        const buildWpData = () => {
            return {
                url: props.siteName === "" ? selectedSite.value.siteName : props.siteName,
                brand: props.brand === "" ? selectedSite.value.brand : props.brand,
                path: path.value,
                deviceMode: "mobile",
                serverLocation: serverLocation.value,
            };
        };
        onBeforeMount(async () => {
            checkForResults();
            if (props.isModal && props.siteName) {
                if (props.slug == "load-testing" || props.slug == "seo") {
                    await canUserAccessSiteName(userId.value, props.siteName);
                }
                else {
                    hasAccess.value = true;
                }
            }
        });
        const checkForResults = () => {
            const interval = setInterval(async () => {
                if (launchedTaskArray.value.length > 0) {
                    const currentTime = new Date().getTime();
                    for (let i = 0; i < launchedTaskArray.value.length; i++) {
                        const element = launchedTaskArray.value[i];
                        const durationEndTime = element.durationTime + currentTime;
                        if (currentTime >= durationEndTime) {
                            handleDurationExceeded(interval);
                            break;
                        }
                        const result = await checkWebPageTestStatus(element.id);
                        if (result.status === "Succeeded" || result.status === "Failed") {
                            handleTaskFinished(interval, result, element);
                            break;
                        }
                    }
                }
            }, 20000);
            return interval;
        };
        const handleDurationExceeded = (interval) => {
            clearInterval(Number(interval));
            notify("", `Task: ${Number(interval)} duration time exceeded`, "warn");
        };
        const handleTaskFinished = (interval, result, element) => {
            eventBus.emit("refresh", "refresh-tasks");
            clearInterval(Number(interval));
            const severity = result.status === "Succeeded" ? "success" : "warn";
            notify(`Task: ${element.id} is finished`, { downloadPath: result.downloadPath }, severity);
        };
        const onRequestAccess = () => {
            if (props.isModal) {
                emit("showRequestView", props.requestView);
            }
            else {
                isModalOpen.value = true;
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (!_ctx.isModal)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.title), 1))
                    : _createCommentVNode("", true),
                (!_ctx.isModal)
                    ? (_openBlock(), _createBlock(WebsiteSelector, {
                        key: 1,
                        modelValue: selectedUrl.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedUrl).value = $event)),
                        class: "wp-pages-inputs"
                    }, null, 8, ["modelValue"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _hoisted_3,
                        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.siteName), 1)
                    ])),
                (!moreOptions.value && _ctx.slug != 'seo')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 3,
                        class: "wp-more-options",
                        onClick: showMoreOptions
                    }, "More Options"))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        (_ctx.slug === 'load-testing')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createVNode(OneDeskInput, {
                                    modelValue: rps.value,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((rps).value = $event)),
                                    class: "wp-pages-inputs"
                                }, {
                                    label: _withCtx(() => [
                                        _hoisted_6
                                    ]),
                                    _: 1
                                }, 8, ["modelValue"]),
                                _createVNode(OneDeskInput, {
                                    modelValue: sitemap.value,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((sitemap).value = $event)),
                                    class: "wp-pages-inputs"
                                }, {
                                    label: _withCtx(() => [
                                        _hoisted_7
                                    ]),
                                    _: 1
                                }, 8, ["modelValue"])
                            ], 64))
                            : _createCommentVNode("", true),
                        (_ctx.slug === 'page-performance' || _ctx.slug === 'accessibility')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createVNode(OneDeskInput, {
                                    modelValue: path.value,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((path).value = $event)),
                                    class: "wp-pages-inputs"
                                }, {
                                    label: _withCtx(() => [
                                        _hoisted_8
                                    ]),
                                    _: 1
                                }, 8, ["modelValue"]),
                                _createVNode(OneDeskDropdown, {
                                    modelValue: serverLocation.value,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((serverLocation).value = $event)),
                                    options: serverLocationOptions,
                                    class: "wp-pages-inputs",
                                    "linera-label": false,
                                    "full-width": true
                                }, {
                                    label: _withCtx(() => [
                                        _hoisted_9
                                    ]),
                                    _: 1
                                }, 8, ["modelValue"])
                            ], 64))
                            : _createCommentVNode("", true)
                    ])),
                (showAccessBlock.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("span", _hoisted_11, [
                            _createTextVNode("You need to request an access on "),
                            _createElementVNode("b", null, _toDisplayString(computedSelected.value.siteName), 1),
                            _createTextVNode(" before running "),
                            _createElementVNode("b", null, _toDisplayString(testTypeLabel.value), 1)
                        ]),
                        _createVNode(OneDeskButton, {
                            class: "wp-request-access-button",
                            "with-radius": true,
                            onClick: onRequestAccess
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(" Request access ")
                            ]),
                            _: 1
                        }),
                        _createVNode(RequestAccessModal, {
                            modelValue: isModalOpen.value,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((isModalOpen).value = $event)),
                            "full-url": computedSelected.value.fullSiteName,
                            "site-name": computedSelected.value.siteName,
                            brand: computedSelected.value.brand,
                            market: computedSelected.value.market
                        }, null, 8, ["modelValue", "full-url", "site-name", "brand", "market"])
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_12, [
                    _createVNode(OneDeskButton, {
                        class: "wp-launch-button",
                        onClick: launch,
                        disabled: disabled.value || isLoading.value,
                        label: "Launch",
                        icon: "pi pi-play"
                    }, null, 8, ["disabled"]),
                    (showCancelButton.value)
                        ? (_openBlock(), _createBlock(OneDeskButton, {
                            key: 0,
                            class: "cancel-button",
                            onClick: _ctx.closeModal,
                            label: "Cancel",
                            icon: "pi pi-times-circle",
                            severity: "secondary"
                        }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                ])
            ], 64));
        };
    }
});
